import React, { useState, useEffect, useMemo } from "react";
import { StatusChips } from "./statusChips/StatusChips";
import BookingDataGrid from "./bookingDataGrid/bookingDataGrid";
import DateFilter from "./dateFilter/dateFilter";
import axios from "../../../../network/api";
import { getConfig } from "../../../../network/auth";
import AppConstants from "../../../AppConstants";
import { baseUrl } from "../../../../network/constants/constants";
import "./BookingDetails.css";
import { Row, Col, Spinner } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";

export const BookingDetails = () => {
  const [pagination, setPagination] = useState({
    pageSize: 25,
    page: 1,
  });

  const [bookingList, setBookingList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);



  let bID = localStorage.getItem(AppConstants.business_id);

  const fetchBooking = (start_date = null, end_date = null, status = []) => {
    setLoading(true);
    axios
      .get(baseUrl + `businessadmin/booking-history-by-business/${bID}`, {
        params: {
          start_date: start_date || "",
          end_date: end_date || "",
          status: status || [],
          // page: pagination.page || 1,
          // size: pagination.pageSize || 25
        },
        ...config,
      })
      .then((response) => {
        setBookingList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Booking Error:", error);
        setLoading(false);
      });
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setStatus([]);
    fetchBooking();
    setSnackbarMessage("Filters reset successfully.");
    setSnackbarSeverity("info");
    setSnackbarOpen(true);
  };

  const handleFilterBookings = () => {
    if (!bookingList || bookingList.length === 0) {
      setSnackbarMessage("No payment records to filter.");
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    if (!startDate || !endDate) {
      setSnackbarMessage("Please select both start and end dates.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (bookingList.length === 0) {
      setSnackbarMessage("No records found within the selected range.");
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
    } else {
      setSnackbarMessage("Filters applied successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
    fetchBooking(startDate, endDate, status);
  };

  useEffect(() => {
    fetchBooking();
  }, []);

  return (
    <div className="booking-details">
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row>
            <Col>
              <StatusChips status={status} setStatus={setStatus} />
            </Col>
            <Col>
              <DateFilter
                bookingList={bookingList}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setSnackbarMessage={setSnackbarMessage}
                setSnackbarOpen={setSnackbarOpen}
                setSnackbarSeverity={setSnackbarSeverity}
                handleFilterBookings={handleFilterBookings}
                setStatus={setStatus}
                setBookingList={setBookingList}
                handleReset={handleReset}
              />
            </Col>
          </Row>
          <BookingDataGrid
            bookingList={bookingList}
            startDate={startDate}
            endDate={endDate}
            handleFilterBooking={handleFilterBookings}
            setPagination={setPagination}
          />

          <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
              {snackbarMessage}
            </Alert>
          </Snackbar>
        </>
      )}
    </div>
  );
};






